/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseCustomerMemo } from '../../models/response-customer-memo';

export interface GetCustomerMemosFor$Params {
  customerId: number;
  createdDate?: string;
  text?: string;
  createdBy?: string;
  origin?: string;
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export function getCustomerMemosFor(http: HttpClient, rootUrl: string, params: GetCustomerMemosFor$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseCustomerMemo>> {
  const rb = new RequestBuilder(rootUrl, getCustomerMemosFor.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('createdDate', params.createdDate, {});
    rb.query('text', params.text, {});
    rb.query('createdBy', params.createdBy, {});
    rb.query('origin', params.origin, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseCustomerMemo>;
    })
  );
}

getCustomerMemosFor.PATH = '/customermemo/{customerId}';
